module.exports = __webpack_public_path__ + "static/media/nuts.ec2c3dd9.jpg";